import type { OptionsEnhancer } from '@nvision/services/fetcher';

import { ENV_VARS } from '@/env';
import { authService, logOut } from '@/modules/auth';

import { logger } from './logger';

export const getSelectedCompanyId = () => {
  const companyId = localStorage.getItem('selectedCompanyId');
  return companyId && companyId !== 'undefined' && companyId.trim() !== '' ? companyId : null;
};

export const withSelectedCompanyId = (): OptionsEnhancer => (opts) => ({
  ...opts,
  hooks: {
    ...opts.hooks,
    beforeRequest: [
      ...(opts.hooks?.beforeRequest ?? []),
      (request) => {
        const selectedCompanyId = getSelectedCompanyId();
        if (selectedCompanyId) {
          request.headers.set('X-Company-Id', selectedCompanyId);
        }
        return request;
      },
    ],
  },
});

export const withAuth = (): OptionsEnhancer => (opts) => ({
  ...opts,
  hooks: {
    ...opts.hooks,
    afterResponse: [
      async (_request, _options, response) => {
        // const data = await response.json();
        // response.data = data;
        if (!response.ok) {
          logger.error('[fetcher]: Request failed:', response.status, response.statusText);
        }
        // biome-ignore lint/style/noMagicNumbers: 401 status
        if (response.status === 401) {
          logOut();
        }
        // TODO: check for what case need check ERR_CANCELED
        //   if (response?.code === 'ERR_CANCELED') {
        //     return Promise.resolve({ status: 499 });
        //   }
        return response;
      },
    ],
    beforeRequest: [
      // TODO: check nesting array
      // ...(opts.hooks?.beforeRequest ?? []),
      async (request) => {
        if (authService.accessToken) {
          request.headers.set('Authorization', `Bearer ${authService.accessToken}`);
        }
        // TODO: check merge hooks, remove it after
        const selectedCompanyId = getSelectedCompanyId();
        if (selectedCompanyId) {
          request.headers.set('X-Company-Id', selectedCompanyId);
        }

        return request;
      },
    ],
  },
});

export const withObsoleteEndpointLogger = (): OptionsEnhancer => {
  if (!ENV_VARS.REACT_APP_LOG_OBSOLETE_ENDPOINTS) {
    return (options) => options;
  }

  return (options) => ({
    ...options,
    hooks: {
      ...options.hooks,
      afterResponse: [
        ...(options.hooks?.afterResponse ?? []),
        (request, _options, response) => {
          const obsoleteHeader = response.headers.get('x-obsolete-endpoint');

          if (obsoleteHeader) {
            console.warn('[OBSOLETE ENDPOINT USED]', {
              headerValue: obsoleteHeader,
              method: request.method,
              status: response.status,
              url: request.url,
            });
          }
        },
      ],
    },
  });
};
